import {
  GetProcessAnalyticsDocument,
  GetProcessAnalyticsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useProcessAnalytics = (variables: GetProcessAnalyticsQueryVariables) => {
  const { data, loading } = useQuery(GetProcessAnalyticsDocument, {
    variables: {
      processId: variables.processId,
      status: variables.status,
      mandatory: variables.mandatory,
      category: variables.category,
    },
  })

  const process = data?.processes.processesConnection.nodes?.at(0)

  const incompletedTasksCount = data?.tasks.incompleted.totalCount

  const pendingProcessesCount = process && process.materializedProcessesConnection.totalCount

  const dueTasksCount = data?.tasks.due.totalCount

  return {
    loading,
    dueTasksCount,
    incompletedTasksCount,
    pendingProcessesCount,
  }
}
